import GuidePageScreen, { generateStaticParams } from '@/components/Guides/GuidePageScreen';

export { generateStaticParams };
export default function DocsDynamicPage() {
  return <GuidePageScreen guideType="docs" />;
}
